<script>
import TablePage from '@/found/components/table_page';
import Modal from '@/found/components/modal';
import Form from './form';

export default {
  name: 'terminal_stop_apply_list',
  extends: TablePage,
  data() {
    return {
      formConfig: {},
      modalConfig: {
        title: '新增',
        visible: false,
        code: '',
      },
    };
  },
  components: {
    Modal,
    Form,
  },
  methods: {
    // 控制按钮显示
    clickVisible({ row, val: { code } }) {
      const { approveStatus } = row;
      if (approveStatus && code === 'edit' && (approveStatus === '2' || approveStatus === '3')) { // 审批中或者通过不能编辑
        return false;
      }
      return true;
    },
    // 按钮点击事件
    modalClick({ val, row }) {
      this.formConfig = {};
      this.formName = 'Form';
      if (val.code === 'add') {
        this.modalConfig.title = '新增';
        this.formConfig = {
          code: val.code,
          id: null,
        };
        this.openFull();
      } else if (val.code === 'edit') {
        this.modalConfig.title = '编辑';
        this.formConfig = {
          code: val.code,
          ...val,
          row,
        };
        this.openFull();
      } else if (val.code === 'view') {
        this.modalConfig.title = '查看';
        this.formConfig = {
          ...val,
          row,
          code: val.code,
        };
        this.openFull();
      }
    },
  },
  created() {
    this.getConfigList('terminal_stop_apply_list');
  },
};
</script>
